import { useQueryClient } from '@tanstack/react-query'

import { useNotesServicePatchV1IndividualsByIndividualIdNotesByNoteIdTitle } from '../client/queries'
import {
  useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteIdKey,
  useNotesServiceGetV1IndividualsByIndividualIdNotesKey,
} from '../client/queries/common'

export const useUpdateNoteTitle = () => {
  const queryClient = useQueryClient()

  return useNotesServicePatchV1IndividualsByIndividualIdNotesByNoteIdTitle({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesKey],
      })
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteIdKey],
      })
    },
  })
}
